import { render, staticRenderFns } from "./RightBar.vue?vue&type=template&id=0b1c3392&scoped=true"
import script from "./RightBar.vue?vue&type=script&lang=ts"
export * from "./RightBar.vue?vue&type=script&lang=ts"
import style0 from "./RightBar.vue?vue&type=style&index=0&id=0b1c3392&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1c3392",
  null
  
)

export default component.exports